import { useCallback } from "react";

import { type QueryClient, useQueryClient } from "@tanstack/react-query";

interface InvalidateReconciliationQueriesOptions {
  includeSuggested?: boolean;
  suggestedStepId?: string;
}

export async function invalidateReconciliationQueries(
  queryClient: QueryClient,
  {
    includeSuggested = false,
    suggestedStepId,
  }: InvalidateReconciliationQueriesOptions = {},
) {
  const queryKeys = [
    ["fetchSubsourceMovements"],
    ["fetchSourceMovements"],
    ["fetchSubsourcePercentages"],
    ["groups"],
  ];

  if (includeSuggested) {
    queryKeys.push(
      suggestedStepId ? ["suggested", suggestedStepId] : ["suggested"],
    );
  }

  await Promise.all(
    queryKeys.map((queryKey) =>
      queryClient.invalidateQueries({
        queryKey,
      }),
    ),
  );
}

export function useReconciliationQueryInvalidation() {
  const queryClient = useQueryClient();

  return useCallback(
    (options?: InvalidateReconciliationQueriesOptions) =>
      invalidateReconciliationQueries(queryClient, options),
    [queryClient],
  );
}
